export const getLocationCardStyles = (
	isSmallScreen?: boolean,
	displayAsScrollableInOneRow?: boolean,
	isCurrentSelectedFacility?: boolean,
	isHorizontalScrolling?: boolean
) => ({
	flexShrink: '0',
	width: displayAsScrollableInOneRow ? '18.75rem' : 'auto',
	borderRadius: '0.5rem',
	border: isCurrentSelectedFacility ? '0.125rem solid' : '0.0625rem solid',
	borderColor: isCurrentSelectedFacility ? 'secondary.main' : 'neutrals.primary',
	boxShadow: 'none',
	backgroundColor: 'neutrals.white',
	marginX: isSmallScreen ? (isHorizontalScrolling ? '0.5rem' : '1rem') : '1.25rem',
	marginBottom: isSmallScreen ? '1.25rem' : '0.5rem',
	minHeight: 'auto',
	maxHeight: isSmallScreen ? '25rem' : 'none',
	height: isSmallScreen ? 'none' : 'fit-content',
	display: isSmallScreen ? 'flex' : 'grid',
	flexDirection: isSmallScreen ? 'column' : 'row',
	justifyContent: isSmallScreen ? 'space-between' : 'unset',
	pb: isSmallScreen ? '1rem' : '0',
});

export const getLocationCardImageStyles = (isSmallScreen?: boolean) => ({
	height: isSmallScreen ? '8.75rem' : '100%',
});

export const getCardTextContainerStyles = (isSmallScreen?: boolean) => {
	const cardTextContainerStyles = {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		flexWrap: 'nowrap',
	};

	if (isSmallScreen) {
		return {
			...cardTextContainerStyles,
			padding: '0.75rem 1rem 0rem 1rem',
			minHeight: 'auto',
		};
	}

	return {
		...cardTextContainerStyles,
		padding: '0.75rem 1rem 0.75rem 1rem',
		minHeight: '11.75rem',
	};
};

export const getCardContentStyles = (isSmallScreen?: boolean) => {
	return {
		paddingRight: 0,
		pb: isSmallScreen ? 0 : '1rem',
		paddingLeft: '1rem',
		width: '100%',
	};
};

export const cardActionStyles = {
	justifyContent: 'start',
	py: '0',
};

export const setAsOfficeButtonStyles = {
	padding: '0',
	marginRight: '-8px',
	marginLeft: 'auto !important',
};

export const getGridDisplayStyles = (isSmallScreen?: boolean) => ({
	display: isSmallScreen ? 'block' : 'flex',
	height: isSmallScreen ? '100%' : 'fit-content',
});

export const getTitleAndDistanceStyles = (
	index?: number,
	isSmallScreen?: boolean,
	isFromGoogleMaps?: boolean,
	isCurrentSelectedFacility?: boolean
) => {
	if (isSmallScreen) {
		return { pt: '0.25rem' };
	}
	if ((index === 0 && !isFromGoogleMaps) || isCurrentSelectedFacility) {
		return { padding: '0.5rem 0' };
	}
	return { padding: '0 0 0.25rem 0' };
};

export const locationCardTitleContainerStyles = {
	display: 'flex',
	alignItems: 'flex-start',
};

export const locationCardDistanceContainerStyles = {
	display: 'flex',
	justifyContent: 'flex-end',
	alignItems: 'flex-start',
};

export const directionsLinkStyles = {
	display: 'flex',
	flexWrap: 'nowrap',
	gap: '0.25rem',
	marginBottom: '.75rem',
};

export const locationCardsInHeaderStyles = (isLocationCardsInHeader: boolean | undefined) => ({
	...(isLocationCardsInHeader && { paddingRight: '1rem' }),
});
